import React from 'react';
import { Trans } from 'react-i18next';
import isArray from 'lodash/isArray';
import { useLocalization } from 'Douleutaras/hooks/localization';

import './ProRating.scss';

const RatingItem = ({ label, value }) => {
  const { formatter } = useLocalization();

  const REVIEW_CATEGORIES_LITERALS = {
    qualityAvgRating: <Trans>T.PROS-PROFILE.RATING.QUALITY-AVG-RATING</Trans>,
    professionalismAvgRating: <Trans>T.PROS-PROFILE.RATING.PROFESSIONALISM-AVG-RATING</Trans>,
    punctualityAvgRating: <Trans>T.PROS-PROFILE.RATING.PUNCTUALITY-AVG-RATING</Trans>,
    priceAvgRating: <Trans>T.PROS-PROFILE.RATING.PRICE-AVG-RATING</Trans>,
    behaviorAvgRating: <Trans>T.PROS-PROFILE.RATING.BEHAVIOR-AVG-RATING</Trans>
  };

  return (
    <div styleName="rating__item" key={label}>
      <div styleName="rating__number">{formatter.number(value)} </div>
      <div styleName="rating__title">{REVIEW_CATEGORIES_LITERALS[label]}</div>
    </div>
  );
};

export const ProRating = ({ aggregates, isCleaner }) => {
  if (!aggregates || typeof aggregates !== 'object' || isArray(aggregates)) {
    // tslint:disable-next-line:no-null-keyword
    return null;
  }

  const reviewCategories = isCleaner
    ? ['qualityAvgRating', 'professionalismAvgRating', 'punctualityAvgRating']
    : ['qualityAvgRating', 'priceAvgRating', 'behaviorAvgRating'];

  return (
    <div styleName="rating">
      {Object.entries(aggregates)
        .filter(([label]) => reviewCategories.includes(label))
        .map(([label, value]) => (
          <RatingItem key={`rating_key_${label}`} label={label} value={value} />
        ))}
    </div>
  );
};
